import React, { useState } from 'react';
import { projectMilestoneServices } from '../../../APIServices/projectMilestoneServices';
import { useToast } from '../../../hooks/useToast';

function AddNewProjectMilestone({ getProjectMilestoneData, setModalOpen }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [projectMilestone, setProjectMilestone] = useState('');
  const [defaultTimelineStatus, setDefaultTimelineStatus] = useState('planned');

  const addNewProjectMilestone = async () => {
    setButtonLoader(true);
    try {
      const data = await projectMilestoneServices.addNewProjectMilestone({
        projectMilestone,
        defaultTimelineStatus,
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Project milestone added successfully.', 'ok');
        setProjectMilestone('');
        setDefaultTimelineStatus('planned');
        getProjectMilestoneData();
        setModalOpen('');
      } else {
        toast(data?.customMessage || 'Unable to add project milestone.', 'warn');
      }
    } catch (error) {
      toast('Unable to add project milestone. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Add Project Milestone</div>
            <div className="xs muted">Create a new milestone name for project tracking metadata</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Project Milestone Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="e.g., Protocol finalization"
              value={projectMilestone}
              onChange={(e) => setProjectMilestone(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Default Timeline Status</label>
            <select
              className="inp"
              disabled={buttonLoader}
              value={defaultTimelineStatus}
              onChange={(e) => setDefaultTimelineStatus(e.target.value)}
            >
              <option value="planned">Planned</option>
              <option value="active">Active</option>
              <option value="at_risk">At risk</option>
              <option value="delayed">Delayed</option>
              <option value="done">Done</option>
            </select>
          </div>
        </div>

        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
            onClick={addNewProjectMilestone}
            disabled={buttonLoader || !projectMilestone}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Adding...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Add Project Milestone</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNewProjectMilestone;
